var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawn-numbers",class:{'retail' : _vm.isRetail}},_vm._l((_vm.max),function(num,index){return _c('DrawnNumber',{key:index,attrs:{"value":_vm.numbers[index] ? _vm.numbers[index] : null,"in-progress":_vm.isInProgress(index),"is-retail":_vm.isRetail,"type":_vm.type}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }